import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import { GlgPopup } from 'SharedComponents'

const DeleteCategoryPopupSimGolf = ({ setDisplayPopup, displayPopup, deleteCategory, setDisplayDrawer }) => {
  const onClose = () => {
    setDisplayPopup(false)
  }

  return (
    <GlgPopup
      modalClass='delete_category_popup'
      title={ window.I18n.t('customer_center_comp.components.sim_golf_labels.remove_category') || '' }
      children={ window.I18n.t('customer_center_comp.components.popup_questions.want_to_delete_long') }
      show={ displayPopup }
      onClose={ onClose }
      onSave={ deleteCategory }
      saveButtonEnabled={ true }
      saveButtonText='Remove'
      closeButtonText='Cancel'
    />
  )
}

DeleteCategoryPopupSimGolf.propTypes = {
  displayPopup: PropTypes.bool.isRequired,
  setDisplayPopup: PropTypes.func.isRequired,
  deleteCategory: PropTypes.func.isRequired,
  setDisplayDrawer: PropTypes.func.isRequired,
}

export default DeleteCategoryPopupSimGolf